// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"0fcded64","386":"5e0aac08","589":"2beb964e"}[chunkId] + ".chunk.css";
};